import 'normalize.css';
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import Navbar from './components/molecules/Navbar';
import HomeMobileMenu from './components/organisms/HomeMobileMenu';
// import ComingSoon from './components/screens/ComingSoon';
import AdminDashboard from './components/screens/admin/';
import Home from './components/screens/Home/';
import LoadingScreen from './components/screens/Loading';
import Register from './components/screens/Registration';
import SignIn from './components/screens/SignIn';
import UnverifiedAdmin from './components/screens/UnverifiedAdmin';
import AdminModalContextProvider from './contexts/AdminModalContexts';
import useWatchUserState from './hooks/useWatchUserState';
import { selectHomeMobileMenuShown } from './store/features/app';
import { selectUserLoginState, selectUserPropsState } from './store/features/user';


//TODO: Implement fullscreen functionality.

// const AdminDashboard = React.lazy(()=>(import("./components/screens/admin/AdminDashboard")))
const Shop = React.lazy(()=>import("./components/screens/shop"))


function App() {

  // const dispatch = useDispatch()
  useWatchUserState()
  
  const isUserLoggedIn = useSelector(selectUserLoginState)
  const account_type = useSelector(selectUserPropsState)?.account_type
  const emailVerified = useSelector(selectUserPropsState)?.emailVerified
  
  const isMobileMenuShown = useSelector(selectHomeMobileMenuShown)

  return (
    <div className={isMobileMenuShown ? "app md:overflow-hidden" : "app"}>

        {
          !isUserLoggedIn? (

              <>

                <Router>

                    <Navbar />
                    <HomeMobileMenu />
                    <Switch>

                        <Route path="/register" exact component={Register} />
                        <Route path="/signin" exact component={SignIn} />
                        <Route path="/" exact component={Home} />
                        <Route exact render={()=><Redirect to="/" />} />

                    </Switch>

                </Router>
              </>

          ):(
              <>
                  {
                    account_type === "admin" && (
                      <Suspense
                        fallback={<LoadingScreen />}
                      >
                        <Router>
                            {
                              emailVerified ? (
                                <AdminModalContextProvider>
                                  <AdminDashboard />
                                </AdminModalContextProvider>
                              ):(
                                <UnverifiedAdmin />
                              )
                            }
                        </Router>
                      </Suspense>
                    )
                  }
                  {
                    account_type === "shopkeeper" && (
                      <Suspense
                        fallback={<LoadingScreen />}
                      >
                        <Router>
                            <Shop />
                        </Router>
                      </Suspense>
                    )
                  }
              </>
          )
        }
      
    </div>
  );
}

// const ForComingSoon = ()=>(

//   <div className="app">
//     <ComingSoon />
//   </div>
  
// );

export default App